import React from 'react';
// styles
import styled from 'styled-components';

const AddCircleIcon = ({ className, ...props }) => (
  <svg
    {...props}
    aria-label="Add"
    className={className}
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 23.5C5.64872 23.5 0.5 18.3513 0.5 12C0.507164 5.6517 5.6517 0.507164 12 0.5C18.3513 0.5 23.5 5.64872 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5ZM6.5 10.5C5.94772 10.5 5.5 10.9477 5.5 11.5V12.5C5.5 13.0523 5.94772 13.5 6.5 13.5H10.25C10.3881 13.5 10.5 13.6119 10.5 13.75V17.5C10.5 18.0523 10.9477 18.5 11.5 18.5H12.5C13.0523 18.5 13.5 18.0523 13.5 17.5V13.75C13.5 13.6119 13.6119 13.5 13.75 13.5H17.5C18.0523 13.5 18.5 13.0523 18.5 12.5V11.5C18.5 10.9477 18.0523 10.5 17.5 10.5H13.75C13.6119 10.5 13.5 10.3881 13.5 10.25V6.5C13.5 5.94772 13.0523 5.5 12.5 5.5H11.5C10.9477 5.5 10.5 5.94772 10.5 6.5V10.25C10.5 10.3881 10.3881 10.5 10.25 10.5H6.5Z"
      fill="#0140CD"
    />
  </svg>
);

export default styled(AddCircleIcon)``;
